/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QueryRequest } from '../../models/query-request';
import { SystemResponse } from '../../models/system-response';

export interface ProcessQueryApiV1ChatQueryPost$Params {
      body: QueryRequest
}

export function processQueryApiV1ChatQueryPost(http: HttpClient, rootUrl: string, params: ProcessQueryApiV1ChatQueryPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SystemResponse>> {
  const rb = new RequestBuilder(rootUrl, processQueryApiV1ChatQueryPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SystemResponse>;
    })
  );
}

processQueryApiV1ChatQueryPost.PATH = '/api/v1/chat/query';
